module.exports = __webpack_public_path__ + "static/1-5c4162a469049020be6497ae28118744.svg";